import { useState, useEffect, useRef } from "react";
import { Col, Row, Container, Modal } from "react-bootstrap";
import "../createslots/createslots.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import CalenderIcon from "../../assets/svgs/calender.svg";
import clockicon from "../../assets/svgs/clock-ivon.svg";
import trashIcon from "../../assets/svgs/trashicon-slots.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFacilitiesForFilters,
  fetchSportsForFilters,
  setSelectedFacility,
  setSelectedSport,
  selectFacilities,
  selectSports,
  selectSelectedFacility,
  selectSelectedSport as selectReduxSelectedSport,
  selectLoading,
} from "../../redux/slices/pitchFiltersSlice";
import { fetchPitches } from "../../redux/viewPitchSlice";
import moment from "moment";
import { createSlot } from "../../redux/slices/slotSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fileIcon from "../../assets/svgs/file.svg";
import sportIcon from "../../assets/svgs/sport-icon.svg";
import facilityIcon from "../../assets/sidepanel/pitch.svg";
import dateIcon from "../../assets/svgs/date-icon.svg";
import daysIcon from "../../assets/svgs/calender-small-icon.svg";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calendar.css";

const MIN_SLOT_MINUTES = 15;
const MAX_SLOT_MINUTES = 8 * 60;

const DURATION_OPTIONS = [
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1.5 hours", value: 90 },
  { label: "2 hours", value: 120 },
  { label: "2.5 hours", value: 150 },
  { label: "3 hours", value: 180 },
  { label: "3.5 hours", value: 210 },
  { label: "4 hours", value: 240 },
  { label: "5 hours", value: 300 },
  { label: "6 hours", value: 360 },
  { label: "8 hours", value: 480 },
];

const dayNumberToName = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const dayNameToNumber = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

const CreateSlots = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const facilities = useSelector(selectFacilities);
  const sports = useSelector(selectSports);
  const loading = useSelector(selectLoading);
  const { loading: slotLoading } = useSelector((state) => state.slots);

  // Basic info
  const [slotName, setSlotName] = useState("");
  const [facility, setFacility] = useState("");
  const [Court, setCourt] = useState("");
  const [localSelectedSport, setLocalSelectedSport] = useState("");
  const [selectedPitchData, setSelectedPitchData] = useState(null);
  const [availablePitches, setAvailablePitches] = useState([]);
  const [paymentType, setPaymentType] = useState("cash");

  // Dates
  const [StartDate, setStartDate] = useState();
  const [EndDate, setEndDate] = useState();
  const [selectedDayNames, setSelectedDayNames] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedDates, setSelectedDates] = useState(new Set());
  const [selectedDatesForCurrentSlot, setSelectedDatesForCurrentSlot] = useState(new Set());
  const [selectedDateForSlots, setSelectedDateForSlots] = useState(null);
  const [excludedDates] = useState(new Set());

  // Time + Duration
  const [startTime, setStartTime] = useState("");
  const [selectedFromMeridiem, setSelectedFromMeridiem] = useState("AM");
  const [showFromTimePicker, setShowFromTimePicker] = useState(false);
  const [durationMinutes, setDurationMinutes] = useState(60);
  const [cost, setCost] = useState("");
  const fromTimePickerRef = useRef(null);

  // Slots data
  const [daySlots, setDaySlots] = useState({});

  // UI
  const [isFormValid, setIsFormValid] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  // ---------- Helpers ----------
  const generateTimeOptions = () => {
    const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));
    const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));
    return { hours, minutes };
  };
  const { hours, minutes } = generateTimeOptions();

  const formatTimeForDisplay = (time, meridiem) => {
    if (!time) return "";
    const [h, m] = time.split(":");
    return `${String(parseInt(h, 10)).padStart(2, "0")}:${m} ${meridiem}`;
  };

  const getEndTimeFromDuration = (fromTime, fromMeridiem, durationMins) => {
    if (!fromTime || !durationMins) return null;
    const fromMoment = moment(`${fromTime} ${fromMeridiem}`, "hh:mm A");
    const toMoment = fromMoment.clone().add(durationMins, "minutes");
    return {
      time12: toMoment.format("hh:mm"),
      meridiem: toMoment.format("A"),
      formatted: toMoment.format("hh:mm A"),
      time24: toMoment.format("HH:mm"),
    };
  };

  const handleTimeSelection = (type, value) => {
    const [currentHours, currentMinutes] = startTime ? startTime.split(":") : ["00", "00"];
    let newTime;
    if (type === "hours") newTime = `${value}:${currentMinutes}`;
    else newTime = `${currentHours}:${value}`;
    setStartTime(newTime);
  };

  const sortSlotsByTime = (slotsToSort) =>
    [...slotsToSort].sort((a, b) =>
      moment(a.fromFormatted, "hh:mm A").diff(moment(b.fromFormatted, "hh:mm A"))
    );

  // ---------- Data fetch ----------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [facilitiesRes, sportsRes, pitchesRes] = await Promise.all([
          dispatch(fetchFacilitiesForFilters()),
          dispatch(fetchSportsForFilters()),
          dispatch(fetchPitches()),
        ]);
        if (pitchesRes.payload) setAvailablePitches(pitchesRes.payload);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchData();
  }, [dispatch]);

  // Click outside time picker
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fromTimePickerRef.current && !fromTimePickerRef.current.contains(event.target)) {
        setShowFromTimePicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ---------- Filters ----------
  const getFilteredPitches = () => {
    if (!facility || !localSelectedSport || !facilities || !sports || !availablePitches) return [];
    const selectedFacilityData = facilities.find((f) => f._id === facility);
    const selectedSportData = sports.find((s) => s._id === localSelectedSport);
    if (!selectedFacilityData?.name || !selectedSportData?.name) return [];

    return availablePitches.filter((pitch) => {
      if (!pitch?.facilityName || !pitch?.sportName) return false;
      return (
        String(pitch.facilityName).toLowerCase() === String(selectedFacilityData.name).toLowerCase() &&
        String(pitch.sportName) === String(selectedSportData.name)
      );
    });
  };

  const getFilteredSports = () => {
    if (!facility) return [];
    const selectedFacilityData = facilities.find((f) => f._id === facility);
    if (!selectedFacilityData?.availableSports) return [];
    return sports.filter((sport) =>
      selectedFacilityData.availableSports.some((s) => s._id === sport._id)
    );
  };

  const getAvailableDaysForFacility = () => {
    if (!facility) return [];
    const selectedFacilityData = facilities.find((f) => f._id === facility);
    if (!selectedFacilityData?.venueTimings) return [];
    return selectedFacilityData.venueTimings.map((t) => t.day);
  };

  const isDayAvailableForFacility = (dayName) => getAvailableDaysForFacility().includes(dayName);

  // ---------- Handlers ----------
  const handleFacilityChange = (e) => {
    const facilityId = e.target.value;
    const selectedFacilityData = facilities.find((f) => f._id === facilityId);

    if (selectedFacilityData && !selectedFacilityData.isActive) {
      toast.error("This facility is not active, so you are not able to create slot.");
    }

    if (selectedFacilityData?.contractTenure) {
      const contractStart = moment(selectedFacilityData.contractTenure.from);
      const contractEnd = moment(selectedFacilityData.contractTenure.to);
      const today = moment();

      if (today.isAfter(contractEnd, "day")) {
        toast.error(
          `Contract tenure has expired on ${contractEnd.format("MMM DD, YYYY")}. Cannot create slots for this facility.`
        );
        return;
      }
      if (today.isBefore(contractStart, "day")) {
        toast.warning(
          `Contract tenure starts on ${contractStart.format("MMM DD, YYYY")}. Slots can only be created from that date onwards.`
        );
      }
    }

    setFacility(facilityId);
    dispatch(setSelectedFacility(facilityId));
    setLocalSelectedSport("");
    setCourt("");
    setSelectedPitchData(null);
    setSelectedDays([]);
    setSelectedDayNames([]);
    setSelectedDates(new Set());
    setSelectedDatesForCurrentSlot(new Set());
    setDaySlots({});
  };

  const handleSportChange = (e) => {
    setLocalSelectedSport(e.target.value);
    dispatch(setSelectedSport(e.target.value));
    setCourt("");
    setSelectedPitchData(null);
  };

  const handlePitchChange = (e) => {
    const pitchId = e.target.value;
    const selectedPitch = availablePitches.find((p) => p._id === pitchId);
    setCourt(pitchId);
    setSelectedPitchData(selectedPitch);
  };

  // ---------- Validation helpers ----------
  const isDateWithinContractTenure = (date) => {
    if (!facility) return true;
    const selectedFacilityData = facilities.find((f) => f._id === facility);
    if (!selectedFacilityData?.contractTenure) return true;
    const contractStart = moment(selectedFacilityData.contractTenure.from);
    const contractEnd = moment(selectedFacilityData.contractTenure.to);
    return moment(date).isBetween(contractStart, contractEnd, "day", "[]");
  };

  const isDateOnAvailableDay = (date) => {
    if (!date || !facility) return false;
    return getAvailableDaysForFacility().includes(moment(date).format("dddd"));
  };

  const isDateInRange = (date) => date >= StartDate && date <= EndDate;

  const isDateSelectable = (date) => {
    const dayName = moment(date).format("dddd");
    const dateStr = moment(date).format("YYYY-MM-DD");
    const startDateStr = StartDate ? moment(StartDate).format("YYYY-MM-DD") : null;

    if (!isDateWithinContractTenure(date)) return false;
    if (dateStr === startDateStr) return true;
    return selectedDayNames.includes(dayName);
  };

  const checkForOverlappingSlots = (newSlot, existingSlots) => {
    const newFrom = moment(newSlot.fromFormatted, "hh:mm A");
    let newTo = moment(newSlot.toFormatted, "hh:mm A");
    if (newTo.isBefore(newFrom)) newTo.add(1, "day");

    for (const existing of existingSlots) {
      const existingFrom = moment(existing.fromFormatted, "hh:mm A");
      let existingTo = moment(existing.toFormatted, "hh:mm A");
      if (existingTo.isBefore(existingFrom)) existingTo.add(1, "day");

      if (newFrom.isBefore(existingTo) && newTo.isAfter(existingFrom)) {
        return { hasOverlap: true, conflictingSlot: existing };
      }
    }
    return { hasOverlap: false };
  };

  // ---------- Date range helpers ----------
  const getDaysBetweenDates = (startDate, endDate) => {
    const dayNames = [];
    const dayNumbers = [];
    const current = new Date(startDate);
    const end = new Date(endDate);

    while (current <= end) {
      const dayName = moment(current).format("dddd");
      if (!dayNames.includes(dayName)) {
        dayNames.push(dayName);
        dayNumbers.push(dayNameToNumber[dayName]);
      }
      current.setDate(current.getDate() + 1);
    }
    return { dayNames, dayNumbers };
  };

  const updateSelectedDates = (start, end, selectedDayNamesList) => {
    const newSelectedDates = new Set();
    const current = new Date(start);
    const endDate = new Date(end);

    while (current <= endDate) {
      const dayName = moment(current).format("dddd");
      if (selectedDayNamesList.includes(dayName)) {
        newSelectedDates.add(moment(current).format("YYYY-MM-DD"));
      }
      current.setDate(current.getDate() + 1);
    }
    setSelectedDates(newSelectedDates);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (EndDate) {
      const { dayNames, dayNumbers } = getDaysBetweenDates(date, EndDate);
      setSelectedDayNames(dayNames);
      setSelectedDays(dayNumbers);
      updateSelectedDates(date, EndDate, dayNames);
    } else {
      const startDayName = moment(date).format("dddd");
      if (!selectedDayNames.includes(startDayName)) {
        setSelectedDayNames((prev) => [...prev, startDayName]);
        setSelectedDays((prev) => [...prev, dayNameToNumber[startDayName]]);
      }
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (StartDate) {
      const { dayNames, dayNumbers } = getDaysBetweenDates(StartDate, date);
      setSelectedDayNames(dayNames);
      setSelectedDays(dayNumbers);
      updateSelectedDates(StartDate, date, dayNames);
    }
  };

  const handleCalendarClick = (date) => {
    if (!isDateInRange(date)) return;

    const dayName = moment(date).format("dddd");
    const dayIndex = dayNameToNumber[dayName];
    if (selectedDays.length === 0) {
      setSelectedDays([dayIndex]);
      setSelectedDayNames([dayName]);
    }

    if (isDateSelectable(date)) {
      setSelectedDateForSlots(date);
      handleDateMultiSelect(date);
    }
  };

  const handleDateMultiSelect = (date) => {
    const dateStr = moment(date).format("YYYY-MM-DD");
    const next = new Set(selectedDatesForCurrentSlot);
    if (next.has(dateStr)) next.delete(dateStr);
    else if (isDateSelectable(date) && !excludedDates.has(dateStr)) next.add(dateStr);
    setSelectedDatesForCurrentSlot(next);
  };

  // ---------- Add / Remove slot ----------
  const addSlot = () => {
    if (selectedDatesForCurrentSlot.size === 0) {
      toast.error("Please select at least one date");
      return;
    }

    const selectedFacilityData = facilities.find((f) => f._id === facility);
    if (selectedFacilityData && !selectedFacilityData.isActive) {
      toast.error("This facility is not active, so you are not able to create slot.");
      return;
    }

    if (!startTime || !cost || !durationMinutes) {
      toast.error("Please fill start time, duration and cost");
      return;
    }

    if (durationMinutes < MIN_SLOT_MINUTES) {
      toast.error(`Slot duration must be at least ${MIN_SLOT_MINUTES} minutes`);
      return;
    }
    if (durationMinutes > MAX_SLOT_MINUTES) {
      toast.error(`Slot duration cannot exceed ${MAX_SLOT_MINUTES / 60} hours`);
      return;
    }

    // Cost vs facility starting price
    if (selectedFacilityData?.startingFrom) {
      const facilityStartingPrice = parseFloat(selectedFacilityData.startingFrom);
      const slotCost = parseFloat(cost);
      if (isNaN(slotCost) || slotCost < facilityStartingPrice) {
        toast.error(
          `Slot cost (PKR ${cost}) cannot be lower than facility starting price (PKR ${facilityStartingPrice})`
        );
        return;
      }
    }

    const endInfo = getEndTimeFromDuration(startTime, selectedFromMeridiem, durationMinutes);
    if (!endInfo) {
      toast.error("Invalid time selection");
      return;
    }

    const fromFormatted = formatTimeForDisplay(startTime, selectedFromMeridiem);
    const toFormatted = endInfo.formatted;

    const newSlot = {
      id: Date.now(),
      from: startTime,
      to: endInfo.time12,
      price: cost.toString(),
      fromFormatted,
      toFormatted,
      durationMinutes,
      paymentType,
    };

    // Overlap check
    let hasOverlap = false;
    let overlapDate = "";
    let conflictingSlot = null;

    selectedDatesForCurrentSlot.forEach((dateStr) => {
      const existing = daySlots[dateStr] || [];
      const check = checkForOverlappingSlots(newSlot, existing);
      if (check.hasOverlap) {
        hasOverlap = true;
        overlapDate = moment(dateStr).format("MMM D, YYYY");
        conflictingSlot = check.conflictingSlot;
      }
    });

    if (hasOverlap) {
      toast.error(
        `Time slot overlaps with existing slot (${conflictingSlot.fromFormatted} – ${conflictingSlot.toFormatted}) on ${overlapDate}`
      );
      return;
    }

    // Add to all selected dates
    selectedDatesForCurrentSlot.forEach((dateStr) => {
      setDaySlots((prev) => ({
        ...prev,
        [dateStr]: sortSlotsByTime([...(prev[dateStr] || []), { ...newSlot }]),
      }));
    });

    // Reset inputs (keep duration for convenience)
    // setStartTime("");
    // setSelectedFromMeridiem("AM");
    // setCost("");

    // Auto-set next start time = previous end time (better UX)
    setStartTime(endInfo.time12);           // e.g. "10:00"
    setSelectedFromMeridiem(endInfo.meridiem); // "AM" or "PM"
    setCost("");                            // still clear cost (user can change price)
    // durationMinutes is already kept
    toast.success(`Slot added for ${selectedDatesForCurrentSlot.size} date(s)`);
  };

  const removeSlot = (day, slotId) => {
    setDaySlots((prev) => ({
      ...prev,
      [day]: prev[day].filter((s) => s.id !== slotId),
    }));
  };

  // ---------- Form validation ----------
  const validateForm = () => {
    const hasBasic =
      !!slotName && !!facility && !!localSelectedSport && !!Court;
    const hasDates = !!StartDate && !!EndDate && selectedDays.length > 0;
    const hasSlots = Object.values(daySlots).some((arr) => arr.length > 0);
    const valid = hasBasic && hasDates && hasSlots;
    setIsFormValid(valid);
    return valid;
  };

  useEffect(() => {
    validateForm();
  }, [
    slotName,
    facility,
    localSelectedSport,
    Court,
    StartDate,
    EndDate,
    selectedDays,
    daySlots,
  ]);

  // ---------- Payload ----------
  const getPayloadData = () => {
    if (!selectedDates || selectedDates.size === 0) {
      toast.error("Please select at least one date");
      return null;
    }

    const allSlots = Object.entries(daySlots).filter(([, slots]) => slots.length > 0);
    if (allSlots.length === 0) {
      toast.error("Please add at least one slot");
      return null;
    }

    const selectedDatesList = Array.from(selectedDates)
      .map((dateStr) => {
        const dateSlots = sortSlotsByTime(daySlots[dateStr] || []);
        const formattedSlots = dateSlots.map((slot) => ({
          from: moment(slot.fromFormatted, "hh:mm A").format("HH:mm"),
          to: moment(slot.toFormatted, "hh:mm A").format("HH:mm"),
          price: slot.price,
          paymentType: slot.paymentType,
        }));
        return {
          date: moment(dateStr).format("YYYY-MM-DD"),
          dayName: moment(dateStr).format("dddd"),
          slots: formattedSlots,
        };
      })
      .filter((d) => d.slots.length > 0);

    if (selectedDatesList.length === 0) {
      toast.error("Please add slots for your selected dates");
      return null;
    }

    return {
      name: slotName,
      sport: localSelectedSport,
      facility,
      pitch: Court,
      date: {
        from: moment(StartDate).format("MM-DD-YYYY"),
        to: moment(EndDate).format("MM-DD-YYYY"),
      },
      selectedDates: selectedDatesList,
    };
  };

  // ---------- Submit ----------
  const handlePreview = () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields before previewing");
      return;
    }
    const selectedFacilityData = facilities.find((f) => f._id === facility);
    if (selectedFacilityData && !selectedFacilityData.isActive) {
      toast.error("This facility is not active, so you are not able to create slot.");
      return;
    }
    setShowPreviewModal(true);
  };

  const handleSubmit = async () => {
    try {
      const selectedFacilityData = facilities.find((f) => f._id === facility);
      if (selectedFacilityData && !selectedFacilityData.isActive) {
        toast.error("This facility is not active, so you are not able to create slot.");
        return;
      }

      if (selectedFacilityData?.contractTenure) {
        const contractStart = moment(selectedFacilityData.contractTenure.from);
        const contractEnd = moment(selectedFacilityData.contractTenure.to);
        const today = moment();

        if (today.isAfter(contractEnd, "day")) {
          toast.error(
            `Contract tenure has expired on ${contractEnd.format("MMM DD, YYYY")}. Cannot create slots.`
          );
          return;
        }
        if (today.isBefore(contractStart, "day")) {
          toast.error(
            `Contract tenure starts on ${contractStart.format("MMM DD, YYYY")}. Cannot create slots before that date.`
          );
          return;
        }
        if (StartDate && !moment(StartDate).isBetween(contractStart, contractEnd, "day", "[]")) {
          toast.error(
            `Start date must be within contract tenure (${contractStart.format("MMM DD, YYYY")} – ${contractEnd.format("MMM DD, YYYY")})`
          );
          return;
        }
        if (EndDate && !moment(EndDate).isBetween(contractStart, contractEnd, "day", "[]")) {
          toast.error(
            `End date must be within contract tenure (${contractStart.format("MMM DD, YYYY")} – ${contractEnd.format("MMM DD, YYYY")})`
          );
          return;
        }
      }

      const payload = getPayloadData();
      if (!payload) return;

      await dispatch(createSlot(payload)).unwrap();
      toast.success("Slot created successfully!");
      navigate("/slots");
    } catch (error) {
      console.error("Failed to create slot:", error);
      toast.error(error.message || "Failed to create slot. Please try again.");
    }
  };

  // ---------- Grouping for display ----------
  const groupSlotsByDay = (slots) => {
    const grouped = {};
    Object.entries(slots).forEach(([dateStr, daySlotList]) => {
      if (daySlotList.length > 0) {
        const dayName = moment(dateStr).format("dddd");
        if (!grouped[dayName]) grouped[dayName] = [];
        grouped[dayName].push({
          date: dateStr,
          slots: sortSlotsByTime(daySlotList),
        });
      }
    });
    return grouped;
  };

  // ---------- Preview Modal ----------
  const renderPreviewModal = () => {
    const facilityData = facilities.find((f) => f._id === facility);
    const sportData = sports.find((s) => s._id === localSelectedSport);
    const pitchData = availablePitches.find((p) => p._id === Court);

    const groupedSlots = Object.entries(daySlots)
      .filter(([, s]) => s.length > 0)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([date, s]) => ({ date, slots: sortSlotsByTime(s) }));

    const totalSlots = groupedSlots.reduce((n, g) => n + g.slots.length, 0);
    const prices = groupedSlots.flatMap((g) => g.slots.map((s) => Number(s.price)));
    const minPrice = prices.length ? Math.min(...prices) : 0;
    const maxPrice = prices.length ? Math.max(...prices) : 0;

    const basicInfo = [
      { icon: fileIcon, label: "Slot Name", value: slotName },
      { icon: facilityIcon, label: "Facility", value: facilityData?.name },
      { icon: sportIcon, label: "Sport", value: sportData?.name },
      { icon: facilityIcon, label: "Pitch / Court", value: pitchData?.name },
    ];

    return (
      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        centered
        scrollable
        size="xl"
        className="slot-preview-modal"
      >
        <Modal.Header closeButton>
          <div>
            <Modal.Title>Preview Slot Details</Modal.Title>
            <p className="sp-subtitle">Review everything before creating</p>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="sp-stats">
            <div className="sp-stat">
              <span className="sp-stat-value">{groupedSlots.length}</span>
              <span className="sp-stat-label">Dates</span>
            </div>
            <div className="sp-stat">
              <span className="sp-stat-value">{totalSlots}</span>
              <span className="sp-stat-label">Total slots</span>
            </div>
            <div className="sp-stat">
              <span className="sp-stat-value">
                {minPrice === maxPrice ? `PKR ${minPrice}` : `PKR ${minPrice} – ${maxPrice}`}
              </span>
              <span className="sp-stat-label">Price range</span>
            </div>
          </div>

          <section className="sp-card">
            <h6 className="sp-card-title">Basic Info</h6>
            <div className="sp-info-grid">
              {basicInfo.map((item) => (
                <div className="sp-info-item" key={item.label}>
                  <div className="sp-info-icon">
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="sp-info-text">
                    <span className="sp-info-label">{item.label}</span>
                    <span className="sp-info-value">{item.value || "—"}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="sp-card">
            <h6 className="sp-card-title">Schedule</h6>
            <div className="sp-range">
              <div className="sp-range-box">
                <img src={dateIcon} alt="" />
                <div>
                  <span className="sp-info-label">From</span>
                  <span className="sp-info-value">
                    {StartDate ? moment(StartDate).format("DD MMM YYYY") : "—"}
                  </span>
                </div>
              </div>
              <span className="sp-range-arrow">→</span>
              <div className="sp-range-box">
                <img src={dateIcon} alt="" />
                <div>
                  <span className="sp-info-label">To</span>
                  <span className="sp-info-value">
                    {EndDate ? moment(EndDate).format("DD MMM YYYY") : "—"}
                  </span>
                </div>
              </div>
            </div>
            <div className="sp-days">
              {selectedDayNames.map((day) => (
                <span className="sp-day-chip" key={day}>
                  <img src={daysIcon} alt="" />
                  {day}
                </span>
              ))}
            </div>
          </section>

          <section className="sp-card">
            <h6 className="sp-card-title">Time Slots by Date</h6>
            {groupedSlots.length > 0 ? (
              <div className="sp-dates-grid">
                {groupedSlots.map(({ date, slots }) => (
                  <div key={date} className="sp-date-card">
                    <div className="sp-date-header">
                      <div className="sp-date-title">
                        <img src={dateIcon} alt="" />
                        <span>{moment(date).format("MMM D, YYYY")}</span>
                      </div>
                      <span className="sp-date-day">{moment(date).format("dddd")}</span>
                    </div>
                    <ul className="sp-slot-list">
                      {slots.map((slot) => (
                        <li key={slot.id} className="sp-slot">
                          <div className="sp-slot-time">
                            <img src={clockicon} alt="" />
                            {slot.fromFormatted} – {slot.toFormatted}
                          </div>
                          <span className="sp-slot-price">PKR {slot.price}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              <div className="sp-empty">No time slots added yet</div>
            )}
          </section>
        </Modal.Body>

        <Modal.Footer>
          <button className="sp-btn sp-btn-ghost" onClick={() => setShowPreviewModal(false)}>
            Cancel
          </button>
          <button className="sp-btn sp-btn-primary" onClick={handleSubmit} disabled={slotLoading}>
            {slotLoading ? "Creating…" : "Create Slot"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  // ---------- Calculated end time preview ----------
  const calculatedEnd = getEndTimeFromDuration(startTime, selectedFromMeridiem, durationMinutes);

  // ---------- Render ----------
  return (
    <Container className="facilities-container">
      <h1 className="container-title">Create Slots</h1>

      <div className="slots-form-card">
        {/* ===== Basic Info ===== */}
        <div className="slots-info-section">
          <h2>Slots Info</h2>

          <div className="form-row">
            <div className="form-group">
              <label>Slot Name</label>
              <input
                type="text"
                className="form-input"
                value={slotName}
                onChange={(e) => setSlotName(e.target.value)}
                placeholder="Enter slot name"
              />
            </div>
            <div className="form-group">
              <label>Facility</label>
              <select className="form-input" value={facility} onChange={handleFacilityChange}>
                <option value="" disabled>
                  Select facility
                </option>
                {facilities.map((f) => (
                  <option key={f._id} value={f._id}>
                    {f.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Sports</label>
              <select
                className="form-input"
                value={localSelectedSport}
                onChange={handleSportChange}
                disabled={!facility || facilities.find((f) => f._id === facility)?.isActive === false}
              >
                <option value="" disabled>
                  {facility && facilities.find((f) => f._id === facility)?.isActive === false
                    ? "Facility is not active"
                    : "Select sports"}
                </option>
                {getFilteredSports().map((sport) => (
                  <option key={sport._id} value={sport._id}>
                    {sport.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Pitch / Court</label>
              <select
                className="form-input"
                value={Court}
                onChange={handlePitchChange}
                disabled={!localSelectedSport}
              >
                <option value="" disabled>
                  Select pitch/court
                </option>
                {getFilteredPitches().map((pitch) => (
                  <option key={pitch._id} value={pitch._id}>
                    {pitch.name} – {pitch.maxPlayers} players
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Payment Mode</label>
            <select
              className="form-input"
              value={paymentType}
              onChange={(e) => setPaymentType(e.target.value)}
            >
              <option value="cash">Cash</option>
            </select>
          </div>
        </div>

        {/* ===== Dates ===== */}
        <div className="dates-section">
          <h2>Select Dates</h2>

          {facility &&
            (() => {
              const selectedFacilityData = facilities.find((f) => f._id === facility);
              if (!selectedFacilityData?.contractTenure) return null;

              const contractStart = moment(selectedFacilityData.contractTenure.from);
              const contractEnd = moment(selectedFacilityData.contractTenure.to);
              const today = moment();

              let statusClass = "contract-tenure-info";
              let statusText = "";
              let noteText = "Slots can only be created within the contract tenure period.";

              if (today.isAfter(contractEnd, "day")) {
                statusClass += " expired";
                statusText = " (EXPIRED)";
                noteText = "Contract has expired. Cannot create slots for this facility.";
              } else if (today.isBefore(contractStart, "day")) {
                statusClass += " not-started";
                statusText = " (NOT STARTED)";
                noteText =
                  "Contract has not started yet. Slots can only be created from the start date onwards.";
              } else {
                statusClass += " active";
                statusText = " (ACTIVE)";
              }

              return (
                <div className={statusClass}>
                  <p className="contract-tenure-text">
                    <strong>Contract Period:</strong>{" "}
                    {contractStart.format("MMM DD, YYYY")} – {contractEnd.format("MMM DD, YYYY")}
                    {statusText}
                  </p>
                  <p className="contract-tenure-note">{noteText}</p>
                </div>
              );
            })()}

          <div className="form-row">
            <div className="form-group">
              <label>From</label>
              <div className="date-input-wrapper">
                <DatePicker
                  selected={StartDate}
                  onChange={handleStartDateChange}
                  minDate={
                    facility
                      ? (() => {
                        const f = facilities.find((x) => x._id === facility);
                        if (f?.contractTenure) {
                          const contractStart = new Date(f.contractTenure.from);
                          const today = new Date();
                          return contractStart > today ? contractStart : today;
                        }
                        return new Date();
                      })()
                      : new Date()
                  }
                  maxDate={
                    facility
                      ? (() => {
                        const f = facilities.find((x) => x._id === facility);
                        return f?.contractTenure?.to ? new Date(f.contractTenure.to) : null;
                      })()
                      : null
                  }
                  filterDate={(date) =>
                    isDateWithinContractTenure(date) &&
                    isDateOnAvailableDay(date) &&
                    date >= new Date().setHours(0, 0, 0, 0)
                  }
                  customInput={
                    <input
                      type="text"
                      className="form-input"
                      value={StartDate ? moment(StartDate).format("DD-M-YYYY") : ""}
                      readOnly
                    />
                  }
                />
                <img src={CalenderIcon} alt="Calendar" className="calendar-icon" />
              </div>
            </div>

            <div className="form-group">
              <label>To</label>
              <div className="date-input-wrapper">
                <DatePicker
                  selected={EndDate}
                  onChange={handleEndDateChange}
                  minDate={StartDate}
                  maxDate={
                    facility
                      ? (() => {
                        const f = facilities.find((x) => x._id === facility);
                        return f?.contractTenure?.to ? new Date(f.contractTenure.to) : null;
                      })()
                      : null
                  }
                  filterDate={(date) =>
                    isDateWithinContractTenure(date) &&
                    isDateOnAvailableDay(date) &&
                    date >= new Date().setHours(0, 0, 0, 0)
                  }
                  customInput={
                    <input
                      type="text"
                      className="form-input"
                      value={EndDate ? moment(EndDate).format("DD-M-YYYY") : ""}
                      readOnly
                    />
                  }
                />
                <img src={CalenderIcon} alt="Calendar" className="calendar-icon" />
              </div>
            </div>
          </div>
        </div>

        {/* ===== Days + Time Slots ===== */}
        <div className="days-section">
          <h2>Select Days</h2>
          <p className="days-subtitle">Days (can select multiple)</p>

          {facility && (
            <div className="venue-timing-info">
              <p className="venue-timing-text">
                Available days for selected facility: {getAvailableDaysForFacility().join(", ") || "—"}
              </p>
            </div>
          )}

          <div className="days-buttons">
            {dayNumberToName.map((day, index) => {
              const isAvailable = isDayAvailableForFacility(day);
              return (
                <button
                  key={day}
                  className={`day-button ${selectedDays.includes(index) ? "active" : ""} ${!isAvailable ? "disabled" : ""
                    }`}
                  disabled={!isAvailable}
                  onClick={() => {
                    if (!isAvailable) return;
                    const next = selectedDays.includes(index)
                      ? selectedDays.filter((d) => d !== index)
                      : [...selectedDays, index];
                    setSelectedDays(next);
                    const names = next.map((n) => dayNumberToName[n]);
                    setSelectedDayNames(names);
                    if (StartDate && EndDate) updateSelectedDates(StartDate, EndDate, names);
                  }}
                >
                  {day}
                  {!isAvailable && <span className="unavailable-indicator">(Not Available)</span>}
                </button>
              );
            })}
          </div>

          {/* Add Time Slots */}
          <div className="slot-form-section">
            <div className="form-header">
              <h3 className="add-time-slots-title">Add Time Slots</h3>
              <div className="calendar-hint">
                Click dates on calendar to add slots for multiple days
                <button
                  className="view-calendar-btn"
                  onClick={() => {
                    if (selectedDays.length === 0 && (!StartDate || !EndDate)) {
                      toast.error("Select days or set a date range first");
                      return;
                    }
                    setShowCalendar(true);
                  }}
                >
                  View Calendar
                </button>
              </div>
            </div>

            {selectedDatesForCurrentSlot.size > 0 && (
              <div className="selected-dates-list">
                {Array.from(selectedDatesForCurrentSlot).map((dateStr) => (
                  <span key={dateStr} className="selected-date-chip">
                    {moment(dateStr).format("ddd, MMM D")}
                    <button
                      className="remove-date"
                      onClick={() => handleDateMultiSelect(new Date(dateStr))}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}

            {/* From + Duration + Cost */}
            {/* From + Duration only */}
            <div className="time-inputs">
              {/* FROM */}
              <div>
                <div className="input-group">
                  <label>From</label>
                  <div className="time-picker-wrapper" ref={fromTimePickerRef}>
                    <div
                      className="time-picker-input"
                      onClick={() => setShowFromTimePicker(!showFromTimePicker)}
                    >
                      {startTime
                        ? formatTimeForDisplay(startTime, selectedFromMeridiem)
                        : "Select start time"}
                    </div>

                    {showFromTimePicker && (
                      <div className="time-picker-dropdown">
                        <div className="time-column">
                          {hours.map((hour) => (
                            <div
                              key={hour}
                              className={`time-option ${startTime?.split(":")[0] === hour ? "selected" : ""
                                }`}
                              onClick={() => handleTimeSelection("hours", hour)}
                            >
                              {hour}
                            </div>
                          ))}
                        </div>
                        <div className="time-column">
                          {minutes.map((minute) => (
                            <div
                              key={minute}
                              className={`time-option ${startTime?.split(":")[1] === minute ? "selected" : ""
                                }`}
                              onClick={() => handleTimeSelection("minutes", minute)}
                            >
                              {minute}
                            </div>
                          ))}
                        </div>
                        <div className="meridiem-column">
                          <div
                            className={`meridiem-option ${selectedFromMeridiem === "AM" ? "selected" : ""
                              }`}
                            onClick={() => setSelectedFromMeridiem("AM")}
                          >
                            AM
                          </div>
                          <div
                            className={`meridiem-option ${selectedFromMeridiem === "PM" ? "selected" : ""
                              }`}
                            onClick={() => setSelectedFromMeridiem("PM")}
                          >
                            PM
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="end-time-section">
                  <div className="form-group">
                    <label>To</label>
                    <input
                      type="text"
                      className="form-input end-time-input"
                      value={
                        startTime && calculatedEnd
                          ? calculatedEnd.formatted
                          : ""
                      }
                      placeholder="End time"
                      readOnly
                      disabled
                    />
                  </div>
                </div>
              </div>

              {/* DURATION */}
              <div className="input-group">
                <label>Duration</label>
                <div className="duration-chips">
                  {DURATION_OPTIONS.map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`duration-chip ${durationMinutes === opt.value ? "active" : ""}`}
                      onClick={() => setDurationMinutes(opt.value)}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Cost – separate section, left aligned, limited width */}
            <div className="cost-section">
              <div className="form-group">
                <label>Slot Cost</label>
                <div className="cost-input-wrapper">
                  <span className="currency-prefix">PKR</span>
                  <input
                    type="number"
                    className="form-input cost-input"
                    placeholder="0"
                    value={cost}
                    onChange={(e) => setCost(e.target.value)}
                    min="0"
                  />
                </div>
                {facility &&
                  (() => {
                    const f = facilities.find((x) => x._id === facility);
                    return f?.startingFrom ? (
                      <small className="cost-hint">
                        Minimum: PKR {f.startingFrom}. Lower values require changing the facility
                        starting price.
                      </small>
                    ) : null;
                  })()}
              </div>
            </div>

            <button
              className="add-slot-btn"
              onClick={addSlot}
              disabled={selectedDatesForCurrentSlot.size === 0}
            >
              + Add Slot
            </button>
          </div>

          {/* Slots display */}
          <div className="slots-display">
            <Row>
              {Object.entries(groupSlotsByDay(daySlots)).map(([dayName, datesWithSlots]) => (
                <Col md={4} key={dayName} className="mb-4">
                  <div className="day-slots-section">
                    <div className="day-header">
                      <h3 className="day-name">{dayName}</h3>
                      <span className="total-slots">
                        {datesWithSlots.reduce((t, d) => t + d.slots.length, 0)} slots
                      </span>
                    </div>
                    <div className="dates-container">
                      {datesWithSlots.map(({ date, slots }) => (
                        <div key={date} className="date-group">
                          <div className="date-info">
                            <span className="date">{moment(date).format("MMMM D")}</span>
                          </div>
                          <div className="slots-list">
                            {slots.map((slot) => (
                              <div key={slot.id} className="slot-mini-strip">
                                <div className="time-display">
                                  <img src={clockicon} alt="time" className="time-icon" />
                                  {slot.fromFormatted} – {slot.toFormatted}
                                </div>
                                <div className="price">{slot.price} PKR</div>
                                <button
                                  className="delete-btn createslot"
                                  onClick={() => removeSlot(date, slot.id)}
                                  title="Delete slot"
                                >
                                  <img src={trashIcon} alt="delete" />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          {/* Calendar Modal */}
          <Modal
            show={showCalendar}
            onHide={() => setShowCalendar(false)}
            centered
            className="calendar-modal"
            size="lg"
            dialogClassName="calendar-modal-dialog"
          >
            <Modal.Header closeButton>
              <Modal.Title>Select Dates</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-calendar-container">
                <Calendar
                  className="modern-calendar"
                  value={selectedDateForSlots}
                  onChange={handleCalendarClick}
                  minDate={StartDate}
                  maxDate={EndDate}
                  tileClassName={({ date }) => {
                    const dateStr = moment(date).format("YYYY-MM-DD");
                    const startDateStr = StartDate ? moment(StartDate).format("YYYY-MM-DD") : "";
                    const classes = ["calendar-tile"];
                    if (dateStr === startDateStr) classes.push("start-date");
                    if (selectedDatesForCurrentSlot.has(dateStr)) classes.push("selected-for-slot");
                    else if (selectedDates.has(dateStr)) classes.push("selected-date");
                    if (excludedDates.has(dateStr)) classes.push("excluded-date");
                    return classes.join(" ");
                  }}
                  tileDisabled={({ date }) => {
                    const dateStr = moment(date).format("YYYY-MM-DD");
                    const startDateStr = StartDate ? moment(StartDate).format("YYYY-MM-DD") : "";
                    const dayName = moment(date).format("dddd");

                    if (!isDateWithinContractTenure(date)) return true;
                    if (dateStr === startDateStr) return false;
                    if (!isDayAvailableForFacility(dayName)) return true;
                    return !isDateSelectable(date) || !isDateInRange(date);
                  }}
                  formatShortWeekday={(locale, date) => moment(date).format("dd")}
                  formatMonth={(locale, date) => moment(date).format("MMMM YYYY")}
                  nextLabel={<span className="calendar-nav">›</span>}
                  prevLabel={<span className="calendar-nav">‹</span>}
                  next2Label={<span className="calendar-nav">»</span>}
                  prev2Label={<span className="calendar-nav">«</span>}
                />
              </div>
            </Modal.Body>
          </Modal>
        </div>

        <div className="form-actions">
          <button className="preview-button" onClick={handlePreview} disabled={!isFormValid}>
            Preview
          </button>
        </div>
      </div>

      {renderPreviewModal()}
    </Container>
  );
};

export default CreateSlots;